import { render, staticRenderFns } from "./footerbottom.vue?vue&type=template&id=29fb3c13&scoped=true&"
import script from "./footerbottom.vue?vue&type=script&lang=js&"
export * from "./footerbottom.vue?vue&type=script&lang=js&"
import style0 from "./footerbottom.vue?vue&type=style&index=0&id=29fb3c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb3c13",
  null
  
)

export default component.exports